import { Font, Image, StyleSheet, Text, View } from "@react-pdf/renderer";

import React from "react";

Font.register({
  family: "Bauhaus93",
  src: require("@/assets/fonts/Bauhaus93.ttf"),
});

const logo = require(`@/${process.env.REACT_APP_CUSTOMER_REPORT_LOGO}`);

const headerStyles = StyleSheet.create({
  headerContainer: {
    position: "relative",
    marginBottom: 20,
    paddingBottom: 10,
    borderBottom: "0.5pt solid #002B5C",
    minHeight: 90,
    justifyContent: "center",
  },
  logoContainer: {
    position: "absolute",
    left: 10,
    top: "50%",
    marginTop: -28,
    width: 56,
    height: 56,
  },
  logo: {
    width: "100%",
    height: "100%",
  },
  contentContainer: {
    alignItems: "center",
    paddingHorizontal: 80,
  },
  companyName: {
    fontFamily: "Bauhaus93",
    fontSize: 16,
    color: "#002B5C",
    letterSpacing: -1,
    textAlign: "center",
    lineHeight: 0.9,
    marginBottom: 4,
  },
  address: {
    fontFamily: "Times-Roman",
    fontSize: 9.5,
    fontWeight: "bold",
    marginBottom: 1.5,
    textAlign: "center",
    color: "#002B5C",
  },
  contactInfo: {
    fontFamily: "Times-Roman",
    fontSize: 8.5,
    fontWeight: "bold",
    marginBottom: 0,
    color: "#002B5C",
    textAlign: "center",
  },
});

const PDFHeaderGlobo = React.memo(({ documentCode = "" }) => (
  <View style={headerStyles.headerContainer} fixed>
    {documentCode && <Text style={headerStyles.documentCode}>{documentCode}</Text>}

    <View style={headerStyles.logoContainer}>
      <Image src={logo} style={headerStyles.logo} />
    </View>

    <View style={headerStyles.contentContainer}>
      <Text style={headerStyles.companyName}>GLOBO ASIATICO ENTERPRISES, INC.</Text>
      <Text style={headerStyles.address}>JDK Bldg., 127 Maginhawa Street</Text>
      <Text style={headerStyles.address}>Teachers Village-East, Diliman, Quezon City 1101, Philippines</Text>
      <Text style={headerStyles.contactInfo}>Tels. : 982-7000 / 982-7032 to 36</Text>
      <Text style={headerStyles.contactInfo}>Telefax : 982 -8013; 433-0651</Text>
    </View>
  </View>
));

export default PDFHeaderGlobo;
